var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');

var Partners = createReactClass({

    componentDidMount: function(){
        this.addOrbitFeatureIfNeeded();

        $(window).on('changed.zf.mediaquery', this.mediaqueryChangedHandler);
    },

    componentWillUnmount: function(){
        this.removeOrbitFeatureIfNeeded();

        $(window).off('changed.zf.mediaquery', this.mediaqueryChangedHandler);
    },

    addOrbitFeatureIfNeeded: function(){
        if(Foundation.MediaQuery.current !== 'small'){
            return;
        }

        var $partners = $('#partners');
        $partners.find('.row').addClass('orbit-container');
        $partners.find('.column').addClass('orbit-slide');
        $partners.append(`<nav class="orbit-bullets">
          <button class="is-active" data-slide="0"><span class="show-for-sr">AGA</span><span class="show-for-sr">Current Slide</span></button>
          <button data-slide="1"><span class="show-for-sr">Cedars-Sinai</span></button>
          <button data-slide="2"><span class="show-for-sr">University of Michigan Medical School</span></button>
          <button data-slide="3"><span class="show-for-sr">UCLA</span></button>
          <button data-slide="4"><span class="show-for-sr">Ironwood</span></button>
          <button data-slide="5"><span class="show-for-sr">CORE</span></button>
          <button data-slide="6"><span class="show-for-sr">University of Michigan - Center For Health Communications Research</span></button>
          <button data-slide="7"><span class="show-for-sr">Commonwealth Diagnostics International</span></button>
        </nav>`);

        new Foundation.Orbit($partners, {
            autoPlay: false
        });
    },

    removeOrbitFeatureIfNeeded: function(){
        var $partners = $('#partners');
        if(!$partners.find('.orbit-container').length){
            return;
        }

        $partners.off('resizeme.zf.trigger');
        $partners.foundation('destroy').attr('style', '');
        $partners.find('.row').removeClass('orbit-container').attr('style', '');
        $partners.find('.column').removeClass('orbit-slide').attr('style', '');
        $partners.find('.orbit-bullets').remove();
    },

    mediaqueryChangedHandler: function(){
        if(Foundation.MediaQuery.current !== 'small'){
            this.removeOrbitFeatureIfNeeded();
        }else {
            this.addOrbitFeatureIfNeeded();
        }
    },

  render: function(){
    return (
        <div className="content">
            <Helmet
                title="MyGiHealth Partners | Research Institutions &amp; Academic Institutions"
                titleTemplate = "%s"
                meta={[
                    {"property": "description", "content": "My Total Health partners with research & academic institutions, as well as pharma companies, to create educational resources about GI diseases"}
                ]}
            />
            <div className="content-header-wrapper">
                <div className="content-header-small content-header row column">
                    <h1>Partners</h1>
                    <p>Academic Institutions, Centers of Excellence, Industry Leaders and National Institutions</p>
                </div>
            </div>
            <div id="partners">
                <div className="row">
                    <div className="medium-3 column">
                        <a className="partner" href="http://www.gastro.org/">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_aga.jpg" alt="AGA" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://www.cedars-sinai.edu/Research/index.aspx">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_cedars1.jpg" alt="Cedars-Sinai" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://www.med.umich.edu/">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_uMishMed1.jpg" alt="University of Michigan Medical School" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://dgsom.ucla.edu/">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_ucla1.jpg" alt="UCLA" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://www.ironwoodpharma.com/">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_ironwood1.jpg" alt="Ironwood" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://www.cedars-sinai.edu/Research/Research-Areas/CORE/index.aspx">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_nih1_core1-e1430238192334.jpg" alt="CORE" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://chcr.umich.edu/">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/uMish_chcr.jpg" alt="University of Michigan - Center For Health Communications Research" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                    <div className="medium-3 column">
                        <a className="partner" href="http://www.commdx.com/">
                            <span className="img-holder"><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/logos_cdi.jpg" alt="Commonwealth Diagnostics International" /></span>
                            <span className="hollow button">Learn More</span>
                        </a>
                    </div>
                </div>
            </div>
            <div id="points">
                <div className="row">
                    <div className="large-6 column">
                        <div className="point">
                            <p><strong>Leveraging Expertise</strong></p>
                            <p>Drs. Spiegel and Chey have leveraged the considerable clinical, research, health services, and educational expertise of our partners to build MyGiHealth to serve the needs of patients, health care providers and clinical investigators.</p>
                        </div>
                    </div>
                    <div className="large-6 column">
                        <div className="point">
                            <p><strong>Top Caliber</strong></p>
                            <p>My Total Health has partnered with some of the best national research institutions, academic institutions and pharmaceutical companies in the world to further our understanding of GI diseases. Each time you use our products, your information contributes to the collective body of knowledge, helping researchers to learn more about GI conditions that adversely affect millions of people all over the world.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
});

module.exports = Partners;



// WEBPACK FOOTER //
// ./src/common/routes/partners/components/partners.jsx